import React, { useContext, useEffect, useState } from 'react';
import authClient from '../../api/authClient';
import { AuthPageProps } from './models';
import RedirectWhenEnabled, { EnabledRedirect } from './components/RedirectWhenEnabled';
import { LoadingOverlay } from 'packages/smart-home-support/components/LoadingSpinner';
import { useTitle } from 'packages/smart-home-support/hooks';
import { usePartner } from 'packages/smart-home-support/partner';
import { UserContext } from './UserProvider';

const LogoutPage: React.FC<AuthPageProps> = (props) => {
  useTitle('Logging out..');

  const [, partnerController] = usePartner();
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const { setUser } = useContext(UserContext);

  useEffect(() => {
    authClient.signOut().then(() => {
      setUser(null);
      partnerController.setProduct();
      setIsLoggedOut(true);
    });
  }, []);

  const redirects: EnabledRedirect[] = [
    {
      enabled: isLoggedOut,
      to: '/',
    },
  ];

  return (
    <RedirectWhenEnabled redirects={redirects}>
      <LoadingOverlay isFullPage in />
    </RedirectWhenEnabled>
  );
};

export default LogoutPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/LogoutPage.tsx